const Tabs = props => {
  const { formik, name, options } = props || [];
  const value = formik?.values?.[name] || "";

  const handleChange = value => {
    formik?.setFieldValue(name, value);
  };

  const selected = options?.find(option => option?.value === value);
  return (
    <div className="flex min-w-0 flex-col gap-4">
      <div className="flex max-w-full gap-6 overflow-x-auto border-b sm:gap-8">
        {options?.map((item, index) => {
          const isActive = item?.value === value;

          return (
            <div
              className={`shrink-0 cursor-pointer whitespace-nowrap py-2 text-sm font-bold ${isActive ? "border-b border-black text-black" : "text-gray-400"}`}
              key={`${name}${index}`}
              onClick={() => handleChange(item?.value)}
            >
              {item?.label}
            </div>
          );
        })}
      </div>
      {selected?.component}
    </div>
  );
};

export { Tabs };
